module.exports = __webpack_public_path__ + "img/korea-map-watermark.f4f5768.png";